<template>
    <div class="card card-default shadow">
        <div class="card-body">
            <div class="row">

                <div class="col-md-12">

                    <table class=" table table-bordered table-sm" id="bs4-table">
                        <thead class="bg-custom">
                            <tr>
                                <th>Sr.</th>
                                <th>Subject</th>
                                <th>Assignment Title</th>
                                <th>Open From</th>
                                <th>Open Till</th>
                                <th>Status</th>
                                <th>File</th>
                                <th>Feedback</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in tasks">
                                <td>{{index + 1}}</td>
                                <td>{{item.CourseName}}</td>
                                <td>{{item.Name}}</td>
                                <td>{{item.Start}}</td>
                                <td>{{item.End}}</td>
                                <td>
                                    <b v-if="item.ProgramName != 'Pending'" class="text-success ">Submitted</b>
                                    <b v-else class="text-danger">Pending</b>
                                </td>
                                <th>
                                    <!--<button v-if="item.ProgramName != 'Pending'" type="button" style="border: none; background-color:transparent" v-on:click="download(item.SectionID)"><i class="fa fa-download"></i> Download</button>-->
                                    <button v-if="item.ProgramName == 'Pending'" type="button" style="border: none; background-color:transparent" v-on:click="redirectLMS(item.AssignmentID)"><i class="fa fa-upload"></i> Upload</button>
                                </th>
                                <th>
                                    <button v-if="item.FeedbackAttachment != ''" type="button" style="border: none; background-color:transparent" v-on:click="downloadFeedbackAttachment(item.AssignmentChildID, item.FileName)"><i class="fa fa-download"></i> Download</button>
                                </th>
                                <td>{{item.FeedbackRemarks}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>import axios from 'axios';
    export default {
        name: 'fee',
        data() {
            return {
                tasks: [],
                assid: 0,
            }
        },
        created() {
            this.getTasks();
        },
        updated() {
            $('#bs4-table').DataTable();
        },

        methods: {
            getTasks: function () {
                startReq();
                var vm = this;
                axios.post('/api/PortalApi/loadTasks')
                    .then(function (response) {
                        endReq();
                        vm.tasks = response.data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            //download(id) {
            //  var vm = this;
            //  axios.post('/api/PortalApi/storeAssignmentChild?id=' + id)
            //    .then(function (response) {
            //      endReq();
            //      $('#downloadform').submit();
            //    })
            //    .catch(function (error) {
            //      endReq();
            //      console.log(error);
            //    });
            //},

            download(id, filename) {
                startReq()
                toastr.info("It may take some time, do not reload page");
                axios({
                    url: '/api/PortalApi/downloadAssignmentStudent?id=' + id,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            const url =
                                window.URL.createObjectURL
                                    (new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            endReq();
                        } else {
                            endReq();
                            console.error('Error: Received non-200 status code');
                        }
                    })
                    .catch((error) => {
                        endReq();
                        console.error('Error downloading the image:', error);
                    });
            },

            downloadFeedbackAttachment(id, filename) {
                startReq()
                toastr.info("It may take some time, do not reload page");
                axios({
                    url: '/api/PortalApi/downloadFeedbackStudent?id=' + id,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then((response) => {
                        if (response.status === 200) {
                            const url =
                                window.URL.createObjectURL
                                    (new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            endReq();
                        } else {
                            endReq();
                            console.error('Error: Received non-200 status code');
                        }
                    })
                    .catch((error) => {
                        endReq();
                        console.error('Error downloading the image:', error);
                    });
            },


            redirectLMS(id) {
                startReq();
                window.location.href = "../Portal/UploadAssingment?id=" + id;
            },
        }
    }</script>



// WEBPACK FOOTER //
// src/components/school/LMS/assingment.vue